
































import { ActionTypeEnum } from '@empathybroker/tsclient-play/dist/enums/action-type.enum';
import { ToolConfig } from '@empathybroker/tsclient-play/dist/models/instance/tool-config';

import Vue from 'vue';

import { ConfigurationsConfigForm, SynonymsConfigForm, Tabs, ToolConfigForm, UiIconButton, UiMenu } from '../../components';

const BASE_TOOL_ID = 'base';

export default {
  name: 'tools-form',
  props: {
    instance: {
      type: Object,
      required: true
    }
  },
  components: {
    Tabs,
    UiIconButton,
    UiMenu,
    ToolConfigForm,
    SynonymsConfigForm,
    ConfigurationsConfigForm
  },
  computed: {
    toolConfigTypes: function (): any[] {
      return [BASE_TOOL_ID, ActionTypeEnum.SYNONYM, ActionTypeEnum.CONFIGURATION].map(
        (toolId: string) => ({
          id: toolId,
          label: this.messages[toolId].label
        })
      );
    },
    toolsTabs: function (): any[] {
      return this.toolConfigTypes.reduce((toolsTabs: any, toolConfigType: any) => {
        if (!!this.instance.tools[toolConfigType.id]) {
          toolsTabs.push({
            id: toolConfigType.id,
            text: toolConfigType.label,
            closable: (toolConfigType.id !== BASE_TOOL_ID)
          });
        }
        return toolsTabs;
      }, []);
    },
    toolOptions: function (): any[] {
      return this.toolConfigTypes.filter((toolConfigType: any) => !this.instance.tools[toolConfigType.id]);
    },
    computedSelectedToolId: function (): string {
      return (this.selectedToolId || (!!this.toolsTabs[0] && this.toolsTabs[0].id) || '');
    },
    selectedToolConfigComponent: function (): string {
      const toolComponentOptions = {
        [ActionTypeEnum.SYNONYM]: () => SynonymsConfigForm,
        [ActionTypeEnum.CONFIGURATION]: () => ConfigurationsConfigForm,
        default: () => ToolConfigForm
      };
      return (toolComponentOptions[this.computedSelectedToolId] || toolComponentOptions.default)();
    }
  },
  data: function () {
    return {
      selectedToolId: undefined,
      messages: this.$epb.messages.tools.instances.fields.tools
    };
  },
  methods: {
    updateSelectedToolId: function (toolId: string): void {
      this.selectedToolId = toolId;
    },
    addTool: function (option: any): void {
      Vue.set(this.instance.tools, option.id, this.getEmptyToolConfig(option.id));
      this.updateSelectedToolId(option.id);
    },
    removeTool: function (toolId: string): void {
      Vue.delete(this.instance.tools, toolId);
      if (!!this.toolsTabs.length) {
        this.updateSelectedToolId(this.toolsTabs[this.toolsTabs.length - 1].id);
      } else {
        this.updateSelectedToolId(undefined);
      }
    },
    getEmptyToolConfig: function (toolId: string): ToolConfig {
      const baseToolFields: any = {};
      const toolFieldsOptions = {
        [ActionTypeEnum.SYNONYM]: () => ({ ...baseToolFields, types: [] }),
        [ActionTypeEnum.CONFIGURATION]: () => ({ ...baseToolFields, attributeNames: [] }),
        default: () => baseToolFields
      };
      return (toolFieldsOptions[toolId] || toolFieldsOptions.default)();
    }
  },
  created: function (): void {
    if (!Object.keys(this.instance.tools).length) {
      Vue.set(this.instance.tools, BASE_TOOL_ID, {});
      this.updateSelectedToolId(BASE_TOOL_ID);
    }
  }
};
